export enum ABPortalContainerId {
  AB_SAVE_COMPONENT = "ab-save-config-component",
  AB_TITLE_COMPONENT = "ab-title-config-component",
}
